import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type TestTubeIconProps = Partial<SVGIconProps>;

const TestTubeIcon: FC<TestTubeIconProps> = ({
  color = "currentColor",
  ...props
}) => (
  <SVGIcon stroke={color} strokeWidth="4.176" viewBox="0 0 142 142" {...props}>
    <path d="M34.899 34.638c-.548-.814.443-6.107 13.132-9.023s16.325 1.647 15.997 2.885m-29.129 6.138a4.33 4.33 0 0 0 .422.627m-.422-.627l.422.627m0 0l2.438 3.623 12.769 54.38c1.638 6.977 8.607 11.319 15.592 9.713.177-.041.352-.085.526-.132l5.835-30.002-9.342-39.786s.303-1.883.625-3.417m-28.443 5.623c1.229 1.572 5.388 5.392 15.627 3.039 9.497-2.183 12.105-6.58 12.817-8.662m0 0c.24-.703.264-1.142.264-1.142m-.264 1.142c.089-.423.179-.819.264-1.142" />
    <path
      d="M44.38 63.484c8.598 1.171 15.09.663 23.748-6.197"
      strokeLinecap="round"
    />
    <path d="M77.46 36.233c-.192-1.121 3.37-6.242 18.164-3.292s16.465 9.5 15.531 10.652m-33.695-7.36s.402 8.548 15.215 11.501 18.481-4.142 18.481-4.142m-33.695-7.36l1.003 5.849-12.355 63.526c-1.585 8.151 3.715 16.05 11.858 17.673h0c8.197 1.635 16.161-3.708 17.756-11.913l12.326-63.381s1.977-3.001 3.107-4.395" />
    <path
      d="M73.056 75.421c8.528 5.324 15.628 7.873 28.037 4.74"
      strokeLinecap="round"
    />
  </SVGIcon>
);

export default TestTubeIcon;
